import React, { useState } from 'react';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import BucketCard from './BucketCard';
import BucketStats from './BucketStats';
import { Alert, Button } from 'react-bootstrap';
import { LoadingSpinner } from '@/_elements/Loaders';
import { BiPlus } from 'react-icons/bi';
import { toast } from 'react-toastify';
import { fetchWrapper, getTeamIdFromURL } from '@/_helpers';
import Swal from 'sweetalert2';

const BucketList = ({
    buckets,
    bucketStatistics,
    onShowCreateModal,
    onEditBucket,
    onAssignActivityPlan,
    onViewStaff,
    onDragEnd,
    isBusy,
    handleCreateDefaultBuckets = () => {},
    loadData = () => {},
}) => {
    const [isLoading, setIsLoading] = useState(false);
    const teamId = getTeamIdFromURL();
    const handleDeleteBucket = async (bucket) => {
        try {
            const result = await Swal.fire({
                title: 'Are you sure?',
                text: `Do you want to delete the bucket "${bucket.name}"?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#d33',
                cancelButtonColor: '#3085d6',
                confirmButtonText: 'Yes, delete it!',
            });

            if (result.isConfirmed) {
                setIsLoading(true);
                await fetchWrapper.delete(`staffBuckets/${bucket._id}?team=${teamId}`);
                toast.success('Bucket deleted successfully');
                await loadData();
            }
        } catch (error) {
            toast.error(error?.message);
            console.error('Error deleting bucket:', error);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="mt-4">
            <div className="d-flex justify-content-end mb-4">
                <Button variant="primary" onClick={onShowCreateModal}>
                    <BiPlus className="mr-2" /> Create Bucket
                </Button>
                {buckets && buckets.length === 0 && (
                    <Button variant="primary" className="ml-3" onClick={handleCreateDefaultBuckets}>
                        Create Default Buckets
                    </Button>
                )}
            </div>

            <BucketStats stats={bucketStatistics} />

            {isLoading || isBusy ? (
                <div style={{ marginTop: '40px' }}>
                    <LoadingSpinner size={40} />
                </div>
            ) : buckets.length === 0 ? (
                <Alert variant="info">No buckets found.</Alert>
            ) : (
                <DragDropContext onDragEnd={onDragEnd}>
                    <Droppable droppableId="buckets" direction="horizontal">
                        {(provided) => (
                            <div {...provided.droppableProps} ref={provided.innerRef} className="d-flex flex-wrap">
                                {buckets.map((bucket, index) => (
                                    <Draggable key={bucket._id} draggableId={bucket._id} index={index}>
                                        {(provided) => (
                                            <div
                                                ref={provided.innerRef}
                                                {...provided.draggableProps}
                                                {...provided.dragHandleProps}
                                                className="mb-4 mr-4"
                                            >
                                                <BucketCard
                                                    bucket={bucket}
                                                    stats={bucketStatistics?.buckets?.find(
                                                        (stat) => stat._id === bucket._id
                                                    )}
                                                    onEdit={() => onEditBucket(bucket)}
                                                    onAssignPlan={() => onAssignActivityPlan(bucket)}
                                                    onDelete={() => handleDeleteBucket(bucket)}
                                                    onViewStaff={() => onViewStaff(bucket)}
                                                />
                                            </div>
                                        )}
                                    </Draggable>
                                ))}
                                {provided.placeholder}
                            </div>
                        )}
                    </Droppable>
                </DragDropContext>
            )}
        </div>
    );
};

export default BucketList;
